import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { EgiPage, EgiPagesSnapshot } from '@ervo/page-framework';
import { NavigationItemData } from '@/app/platform/platform-shared/models/navigation-item.data';
import { EgiAppData } from '@/app/platform/platform-shared/models/types';

@Injectable({
  providedIn: 'root'
})
export class NavigationItemDataEnricher {
  private readonly egiPages: EgiPage[];

  constructor(egiPagesSnapshot: EgiPagesSnapshot) {
    this.egiPages = egiPagesSnapshot.pages.map(page => cloneDeep(page));
  }

  enrichWithEgiPages(app: EgiAppData): EgiAppData {
    app.rootNavigationItem?.asArray.forEach(i => this.enrichWithEgiPage(i));
    return app;
  }

  enrichWithEgiPage(item: NavigationItemData): void {
    const matchingPage = this.findMatchingEgiPage(item);
    if (matchingPage) {
      item.egiPage = matchingPage;
    }
  }

  private findMatchingEgiPage(item: NavigationItemData): EgiPage | undefined {
    return this.egiPages.find(p => p.config.id === item.pageComponentId);
  }
}
